import {
  AccountInformationsApiProps,
  GetAccountInfoApiProps,
  GetAccountInfoARApiProps,
  UpdateAliasResponseApiProps,
} from 'services/account-info/types'

export const getAccountInfoMock: GetAccountInfoApiProps = {
  title: 'Dados bancários',
  tipoConta: [
    {
      icone: '',
      nome: 'Global Account',
      informacoesConta: [
        {
          titulo: 'Dados de recebimento entre Inter Global Account',
          icone: '',
          itens: [{ titulo: 'Account Number', dados: ['8895373522'], icone: '' }],
          avisos: null as unknown as AccountInformationsApiProps['avisos'],
        },
        {
          titulo: 'Dados de recebimento via ACH',
          icone: '',
          itens: [
            { titulo: 'ACH Routing Number', dados: ['026073150'], icone: '' },
            { titulo: 'Account Number', dados: ['8895373522'], icone: '' },
            {
              titulo: 'Dados do banco parceiro',
              dados: [
                'Community Federal Savings Bank',
                '5 Penn Plz FL 14 New York, NY, 10001-1810',
              ],
              icone: '',
            },
          ],
          avisos: null as unknown as AccountInformationsApiProps['avisos'],
        },
        {
          titulo: 'Dados de recebimento via WIRE Transfer',
          icone: '',
          itens: [
            { titulo: 'WIRE Transfer Routing Number', dados: ['026073008'], icone: '' },
            { titulo: 'Account Number', dados: ['8895373522'], icone: '' },
            {
              titulo: 'Dados do banco parceiro',
              dados: [
                'Community Federal Savings Bank',
                '5 Penn Plz FL 14 New York, NY, 10001-1810',
              ],
              icone: '',
            },
          ],
          avisos: null as unknown as AccountInformationsApiProps['avisos'],
        },
        {
          titulo: 'Dados de recebimento via SWIFT',
          icone: '',
          itens: [
            { titulo: 'Código SWIFT', dados: ['CMFGUS33'], icone: '' },
            { titulo: 'Account Number', dados: ['8895373522'], icone: '' },
            {
              titulo: 'Dados do banco parceiro',
              dados: [
                'Community Federal Savings Bank',
                '5 Penn Plz FL 14 New York, NY, 10001-1810',
              ],
              icone: '',
            },
          ],
          avisos: null as unknown as AccountInformationsApiProps['avisos'],
        },
        {
          titulo: '',
          icone: '',
          itens: [],
          avisos: {
            backgroundColor: '#F5F6FA',
            icone: '',
            titulo: 'Inter&Co',
            mensagem:
              'INTER & CO PAYMENTS, INC., fazendo negócios como inter&co ("Inter&Co"), é uma empresa de tecnologia financeira, uma empresa de serviços monetários registrada (MSB) e uma transmissora de dinheiro licenciada, não um banco (NMLS ID #907330). Massachusetts Foreign Transmittal Agency (License #FT114374-100). Rhode Island Currency Transmitter (License # 20203960CT). Clique aqui para acessar nossas licenças NMLS.  Os serviços bancários são fornecidos pelo Community Federal Savings Bank ("CFSB"), membro do FDIC, e os depósitos são mantidos pelo CFSB e pelo Wells Fargo Bank, membros do FDIC. A Inter&Co não é uma instituição depositária e seus depósitos não são elegíveis para o seguro FDIC.  Para obter mais informações sobre sua Conta Inter&Co, consulte o Contrato de Conta Inter&Co em https://us.inter.co/pt/compliance?contrato-da-conta-interandco  Para fornecer a você a Conta Inter&Co, compartilhamos suas informações com o CFSB. Consulte o Aviso de Privacidade do CFSB em https://www.cfsb.com/privacy/ para obter detalhes.',
          },
        },
      ],
    },
  ],
  entenda: {
    tituloEntenda: 'Entenda',
    enableEntenda: true,
    informacoes: [
      {
        title: 'Qual a diferença entre pagamentos via WIRE Transfer e ACH?',
        message:
          'As principais diferenças estão relacionadas às tarifas de transferência de cada método e seu tempo de processamento. Transferências wire são geralmente mais rápidas, por serem feitas sem intermediários. No entanto, possuem tarifas maiores. Enquanto aquelas via ACH levam mais tempo para serem processadas, pois isso acontece por intermédio de uma rede eletrônica americana em lotes ao longo do dia. Em contrapartida, geralmente são gratuitas ou possuem taxas inferiores.',
        enable: true,
      },
      {
        title:
          'Quais dados bancários preciso informar para receber uma transferência na minha Global Account? ',
        message:
          'Você deve informar os seguintes dados para receber uma transferência em sua Global Account: Account Number, Routing Number, Bank name e Address. Importante lembrar que seu ACH Routing Number e Wire Transfer Routing Number são diferentes.',
        enable: true,
      },
      {
        title: 'Qual a diferença entre account number e routing number?',
        message:
          'O Routing Number é o código do seu banco, ele é usado para identificar instituições bancárias nos Estados Unidos. Enquanto o Account Number é o código que identifica sua conta. Ambos são necessários para fazer transações nos EUA.',
        enable: true,
      },
      {
        title: 'O ACH Routing Number é o mesmo em todos os bancos americanos? ',
        message:
          'O ACH Routing Number varia para cada banco. Alguns bancos inclusive podem ter diferentes números para diferentes estados americanos.',
        enable: true,
      },
      {
        title: 'O que é SWIFT?',
        message:
          'SWIFT (Society for Worldwide Interbank Financial Telecommunication) é uma rede que conecta instituições financeiras de diferentes países. Por meio dela, você consegue transferir dinheiro para bancos em outros países. ',
        enable: true,
      },
      {
        title: 'Quais as características das transferências via SWIFT?',
        message:
          'As transferências via SWIFT são uma forma rápida, segura e rastreável de enviar e receber dinheiro entre países. Por essas características, é comum a cobrança de tarifas por transação.',
        enable: true,
      },
      {
        title: 'Como fazer transferências via SWIFT?',
        message:
          'Para receber dinheiro via SWIFT você precisará informar a quem irá enviar, os seguintes dados: código SWIFT/BIC do banco, o número da conta, nome e o endereço da instituição financeira. ',
        enable: true,
      },
    ],
  },
}

export const getAccountInfoARMock: GetAccountInfoARApiProps = {
  title: 'Datos de la cuenta',
  accounts: [
    {
      type: 'CBU',
      title: 'Cuenta en pesos',
      description: 'Transferencias bancarias locales',
      alias: 'mi.alias.pesos',
      cbuCvu: '2850590940090418135201',
      entity: 'Banco Inter',
      accountNumber: '04181352',
    },
    {
      type: 'CVU',
      title: 'Cuenta virtual',
      description: 'Cobros y transferencias inmediatas',
      alias: 'mi.alias.virtual',
      cbuCvu: '0000003100041813520123',
      entity: 'Inter Pagos',
      accountNumber: '41813520123',
    },
  ],
}

export const updateAliasResponseMock: UpdateAliasResponseApiProps = {
  newAlias: 'nuevo.alias.mock',
}
